import { Link } from "react-router-dom";

const ctaBg = "https://readdy.ai/api/search-image?query=stylized%20warm%20anime%20illustration%20of%20floating%20open%20books%20and%20glowing%20manga%20pages%20in%20a%20sunset%20sky%2C%20coral%20and%20amber%20warm%20tones%2C%20magical%20particles%2C%20dreamy%20cozy%20reading%20atmosphere%2C%20clean%20minimal%20composition&width=1600&height=700&seq=cta-yaojing-2026&orientation=landscape";

export default function Cta() {
  return (
    <section className="relative overflow-hidden">
      <img src={ctaBg} alt="妖精漫画网 阅读收藏行动号召背景" className="absolute inset-0 h-full w-full object-cover object-center" />
      <div className="absolute inset-0 bg-foreground-950/65"></div>
      <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-24">
        <h2 className="font-display text-3xl leading-snug text-background-50 md:text-4xl">
          开始你的漫画收藏之旅
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          把喜欢的作品统一管理，按标签筛选、建立书单、随读随存，追更找漫更省心。现在就去漫画大全逛逛，找到你的下一部心头好。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/library" className="whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
            前往漫画大全
          </Link>
          <Link to="/booklists" className="whitespace-nowrap rounded-full border border-background-50/40 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-500 hover:text-foreground-950">
            逛逛精选书单
          </Link>
        </div>
      </div>
    </section>
  );
}